export const LineHeight = {
  size0: 1,
  size1: 1.1,
  size2: 1.2,
  size3: 1.3,
  size4: 1.4,
  size5: 1.5,
};
